<template>
    <v-layout column fill-height>
        <breadcrumbs :guia="guia" titulo="Materiais de Venda" descricao="Utilize os materiais de venda para fazer ainda + negócios." />
        <v-layout class="main">
            <v-flex>
                <v-layout class="content-body overflow-y-auto">
                    <v-container>
                        <v-row>
                            <v-col cols="6">
                                <v-card class="pa-2" style="height: 150px; background: url('/upload/marketing/banner_nova_tela_produto.png') center center; background-repeat: no-repeat; background-size: cover;" outlined tile>

                                </v-card>
                            </v-col>
                            <v-col cols="6">
                                <v-card class="pa-2 bgCinza" style="height: 150px;" outlined tile>
                                    <v-container>
                                        <v-row style="height:35px !important;">
                                            <v-col md="12">
                                                <h1>{{ guiaMateriais }}</h1>
                                            </v-col>
                                        </v-row>
                                        <v-row style="height:40px !important;" v-for="(links, index) in guiaMateriaisLinks" :key="index">
                                            <v-col md="5" v-for="(linha, subIndex) in links.linha" :key="subIndex">
                                                <v-btn class="btnGuia" @click="abrirDialogGuia(linha.indice)" text depressed>
                                                    <span v-html="linha.texto"></span>
                                                </v-btn>
                                            </v-col>                                            
                                            <v-col md="2">
                                                <v-spacer></v-spacer>
                                            </v-col>                                          
                                        </v-row>
                                    </v-container>
                                </v-card>
                            </v-col>
                        </v-row>
                        <!-- DISPLAY DE DOCUMENTO -->
                        <v-row>
                            <v-col cols="3" v-for="(produto, index) in produtos" :key="index">
                                <v-card @click="abrirPopUpProduto(produto)" class="pa-2" style="height: 140px; padding: 15px 0px 15px 15px !important; cursor:pointer;" outlined tile>
                                    <span class="cardTitulo">{{ produto.nome }} <v-icon v-if="produto.alerta" color="#ffd700">mdi-alarm-light-outline</v-icon></span><br />
                                    Atualizado em {{ produto.atualizadoEm }} <br />
                                    <v-flex class="d-flex flex-row mb-6">
                                        <v-flex class="pa-2" v-for="(documento, indexDoc) in produto.documentos" :key="indexDoc">
                                            
                                            <i v-if="indexDoc < 5" :class="`mdi ${documento.icon} miniIconAzul`" width="34" height="34">
                                                <font style="font-size: 12px; ">&nbsp;{{ documento.tipo }}</font>
                                            </i>                                            
                                        </v-flex>
                                    </v-flex>                                   
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-layout>
            </v-flex>
        </v-layout>
        <!-- DIALOG GUIA MATERIAIS DE VENDA -->
        <v-dialog v-model="dialogGuia" :max-width="1100" :persistent="false">
            <v-card class="bgCinza">
                <v-card-title class="headline">{{ guiaMateriais }}</v-card-title>
                <v-card-text>
                    <v-container class="content-body">
                        <v-row no-gutters style="height: 490px; text-align:center;" align="center" justify="center">
                            <v-col class="overflow-y-auto" style="height: 480px;" >

                                <v-flex v-if="dialogGuiaItemSelecionadoIndex ==  0" style="text-align:justify !important;">
                                    <span class="tituloLista">{{ dialogGuiaItems[dialogGuiaItemSelecionadoIndex] }}</span><br /><br />
                                    
                                    Os materiais de vendas são peças de comunicação criadas para auxiliar você, corretor, na venda dos seguros. Neste menu, você poderá fazer download de materiais como e-mail marketing, posts para redes sociais, folder, entre outros.<br /><br />
                                    
                                    <!-- <img src="/upload/marketing/banner_utilizando_chatbot.png" width="450" height="251" /><br /><br /> -->
                                    <!-- FIQUE ATENTO ÀS ORIENTAÇÕES PARA PRODUZIR MATERIAIS <br />DE DIVULGAÇÃO DO SEU LINK UTILIZANDO SEU LOGO<br /><br />
                                    Primeiro, faça o download dos materiais de <br />divulgação no Portal do Corretor.<br /><br />
                                    Edite os materiais inserrindo seu logo e o seu <br />link e exporte no seu formato preferido.<br /><br />
                                    Distribua os materiais em suas principaipais <br />redes sociais como Whatsapp e Facebook.<br /><br /> -->
                                </v-flex>

                                <v-flex v-if="dialogGuiaItemSelecionadoIndex ==  1" style="text-align:justify !important;">
                                    <span class="tituloLista">{{ dialogGuiaItems[dialogGuiaItemSelecionadoIndex] }}</span><br /><br />

                                    Os materiais de vendas foram criados por uma equipe especializada em publicidade e marketing e têm como objetivo auxiliar você, corretor, na comunicação das coberturas e argumentação dos benefícios dos seguros, contribuindo, assim, para o fechamento de + negócios. <br /><br />
                                    
                                    <!-- <img src="/upload/marketing/banner_material_impresso.png" width="450" height="251" /><br /><br /> -->
                                    <!--     
                                    ESTAS SÃO AS ESPECIFICAÇÕES DOS MATERIAIS QUE <br />VOCÊ PODE SOLICITAR À GRÁFICA:
                                    <br /><br />
                                    <strong>Flyer:</strong> Formato: 10,5 X 15cm (A6), Cores: 4x4, Papel: Couchê Fosco 150g, Acabamento: corte reto, Quantidade: a definir.
                                    <br /><br />
                                    <strong>Banner:</strong> Formato: 0,90 X 1,20m Cores: 4x0, Papel: Lona, Acabamento: bastão, ponteira e corda, Quantidade: a definir.
                                    <br /><br />
                                    <strong>Display:</strong> Base: 24,5x32,5cm, Cores: 4x0 cores, Material: Cartão Duplex 300g, Laminação fosca. Verso: 24,5x32,5cm, sem impressão em Cartão Duplex 350g, corte reto. Bolsa (fechado): 16 x 9,5 x 3cm, 4x0 cores, Cartao Duplex 300g, laminação fosca e vinco. Pé americano: 16x24cm, sem impressão em Duplex 300g, C/ fita Dupla-Face=1.                                 
                                    -->
                                </v-flex>                                

                                <v-flex v-if="dialogGuiaItemSelecionadoIndex ==  2" style="text-align:justify !important;">
                                    <span class="tituloLista">{{ dialogGuiaItems[dialogGuiaItemSelecionadoIndex] }}</span><br /><br />
                                    
                                    Utilizar os materiais de vendas é bastante simples! Veja abaixo o passo a passo:
                                    <br /><br />
                                    <ol>
                                        <li>
                                            Procure pelo produto que você quer vender; <br /><br />
                                            <img src="/upload/marketing/banner_como_utilizar_Imagem_1.png" width="450" height="303" />
                                        </li>
                                        <li>
                                            Clique nos materiais que desejar para fazer download; <br /><br />
                                            <img src="/upload/marketing/banner_como_utilizar_Imagem_2.png" width="450" height="239" />
                                        </li>
                                        <li>
                                            Todos os materiais (com exceção dos vídeos) têm espaço para inclusão do logo da sua corretora e informações de contato (telefone, e-mail, site, etc.). Esse espaço está sinalizado em pontilhado, conforme imagem abaixo: <br /><br />
                                            <img src="/upload/marketing/banner_como_utilizar_Imagem_3.png" width="450" height="451" />
                                        </li>
                                        <li>
                                            Abra os materiais que foram baixados e utilize ferramentas de edição de imagens para inclusão do seu logo e informações (na ausência de ferramenta especializada, vale usar o PowerPoint ou o Paint!); 
                                        </li>
                                        <li>
                                            Pronto! Com suas informações incluídas, os materiais estão prontos para uso. Confira abaixo algumas dicas especiais de utilização de cada um dos materiais.
                                        </li>
                                    </ol>
                                    <br />
                                    <strong>Como utilizar E-mail Marketing</strong><br /><br />
                                    Os e-mails marketing devem ser incluídos no corpo do e-mail, como uma imagem (e não como anexo). <br />
                                    Alguns e-mails marketing contêm um botão de “Clique Aqui”. Para esses e-mails, você deve inserir um hiperlink (ou seja, um caminho de algum site) para direcionar a contratação. Você pode direcionar diretamente para o seu site / rede social; para o link de um WhatsApp da Corretora ou, também, para links de contratação da Previsul.
                                    <br />
                                    <iframe width="450" height="220" src="https://www.youtube.com/embed/BXCYEFY0pwE" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                    <br /><br />

                                    <strong>Como utilizar Post para Redes Sociais</strong><br /><br />
                                    Você pode postar os materiais em suas redes sociais como Facebook, Instagram ou LinkedIn. Não esqueça de caprichar no texto de descrição, utilizando uma linguagem simples, clara e direta. Ah! Aproveite para utilizar emojis também. :)
                                    <br /><br />

                                    <strong>Como utilizar Card de WhatsApp</strong><br /><br />
                                    O WhatsApp é uma importante ferramenta de comunicação com o cliente, não é? Por isso, você pode encaminhar pontualmente o material que disponibilizamos para você ou criar uma lista de transmissão entre seus contatos.<br />
                                    Assim como nas redes sociais, capriche em uma mensagem que acompanhe o card. :)
                                    <br /><br />

                                    <strong>Como utilizar Vídeo</strong><br /><br />
                                    O vídeo é um material bastante versátil e pode ser inserido no seu site, postado nas redes sociais, enviado pelo WhatsApp, entre outros.<br />
                                    Por não ser um material personalizável, é importante que você utilize algum texto de apoio para sinalizar a forma de contratação através da sua corretora.
                                    <br /><br />

                                     <strong>Como utilizar Folder</strong><br /><br />
                                     O folder é um material a ser impresso. Por isso, no arquivo que você baixar, você irá identificar algumas marcações que são para referência de impressão à gráfica.<br />
                                     Todos os folders são em formato A5 (14,8 × 21 cm – ou metade de uma folha de ofício) e devem ser impressos colorido, frente e verso. 
                                     <br /><br />

                                     <strong>Como utilizar Banner</strong><br /><br />
                                     O banner é um material a ser impresso. Por isso, no arquivo que você baixar, você irá identificar algumas marcações que são para referência de impressão à gráfica.<br />
                                     Todos os banners são em formato 0,90 X 1,20 m. Se você não tiver onde pendurar, lembre-se de comprar um porta-banner 
                                     <br /><br />

                                     <strong>Como utilizar Display</strong><br /><br />
                                     O display é um material mais complexo de produção. Envie o arquivo que você baixou para gráfica da sua preferência e sinalize as seguintes especificações técnicas:<br />
                                     <strong>Base:</strong> 24,5x32,5 cm<br />
                                    <strong>Cores:</strong> 4x0 cores<br />
                                    <strong>Material:</strong> Cartão Duplex 300 g Laminação fosca<br />
                                    <strong>Verso:</strong> 24,5x32,5cm, sem impressão em Cartão Duplex 350 g, corte reto<br />
                                    <strong>Bolsa (fechado):</strong> 16 x 9,5 x 3 cm, 4x0 cores, Cartão Duplex 300 g, laminação fosca e vinco<br />
                                    <strong>Pé americano:</strong> 16x24 cm, sem impressão em Duplex 300 g, C/ fita Dupla-Face=1<br />
                                </v-flex> 
                                
                                <v-flex v-if="dialogGuiaItemSelecionadoIndex ==  3" style="text-align:justify !important;">
                                    <span class="tituloLista">{{ dialogGuiaItems[dialogGuiaItemSelecionadoIndex] }}</span><br /><br />
                                    Os materiais disponíveis nesse menu foram desenvolvidos pela equipe de marketing e submetidos à aprovação técnica dos atuários da Previsul. Se você preferir criar um material da sua corretora, divulgando um seguro ou utilizando a marca da Cia, procure seu consultor. Todos os materiais que envolvam a marca da Previsul precisam passar por aprovações internas na seguradora. <br /><br />
                                </v-flex>                                                                
                            </v-col>
                            <v-col>
                                <v-flex style="width:300px; margin:auto;text-align:justify !important;">
                                    <span class="tituloLista">{{ guiaMateriais }}</span><br />
                                    <v-list flat class="bgCinza">
                                        <v-list-item-group v-model="dialogGuiaItemSelecionado" color="primary">
                                            <v-list-item v-for="(item, index) in dialogGuiaItems" :key="index">
                                                <v-list-item-content>
                                                    <v-list-item-title>{{ item }}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>                                                                                                                                                             
                                        </v-list-item-group>
                                    </v-list>
                                </v-flex>
                            </v-col>                            
                        </v-row>
                    </v-container>
                </v-card-text>                
            </v-card>
        </v-dialog>

        <!-- DIALOG PRODUTOS -->
        <v-dialog v-model="dialogProduto" :max-width="1100" :persistent="false" @click:outside="reiniciar()">
            <v-card class="bgCinza">
                <v-card-title class="headline">{{ this.dialogProdutoItem.nome }}</v-card-title>
                <v-card-text>
                    <v-container class="content-body">
                        <v-row no-gutters style="height: 490px; text-align:center;" align="center" justify="center">
                            <v-col class="overflow-y-auto" style="height: 480px;" >
                                <img v-if="validarPreview('img', this.dialogProdutoItem.documentos[this.dialogProdutoItemSelecionadoIndex].preview)" :src="this.dialogProdutoItem.documentos[this.dialogProdutoItemSelecionadoIndex].preview" width="520" />
                                <object v-if="validarPreview('pdf', this.dialogProdutoItem.documentos[this.dialogProdutoItemSelecionadoIndex].preview)" :data="this.dialogProdutoItem.documentos[this.dialogProdutoItemSelecionadoIndex].preview" type="application/pdf" width="520" height="485"></object>
                                
                                <video v-if="validarPreview('video', this.dialogProdutoItem.documentos[this.dialogProdutoItemSelecionadoIndex].preview)" width="520" controls>
                                    <source :src="this.dialogProdutoItem.documentos[this.dialogProdutoItemSelecionadoIndex].preview" type="video/mp4">
                                    Seu Browser não suporta Execução a execução do vídeo. 
                                </video>
                            </v-col>
                            <v-col>
                                <v-flex style="width:300px; margin:auto;">
                                    <span class="tituloLista">{{ this.dialogProdutoItem.nome }}</span><br />
                                    <span style="font-size: 12px;">Atualizado em {{ this.dialogProdutoItem.atualizadoEm }}</span> <br />   
                                    <v-list flat class="bgCinza">
                                        <v-list-item-group v-model="dialogProdutoItemSelecionado" color="primary">
                                            <v-list-item v-for="(documento, index) in this.dialogProdutoItem.documentos" :key="index">
                                                <v-list-item-icon>
                                                    <v-icon class="miniIconAzul">{{ documento.icon }}</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{ documento.tipo }}</v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn v-bind="attrs" v-on="on" icon @click="gerarArquivo(documento.download)">
                                                                <v-icon class="miniIconAzul">mdi-file-download-outline</v-icon> 
                                                            </v-btn>                                                        
                                                        </template>
                                                        <span>Download</span>
                                                    </v-tooltip>
                                                </v-list-item-action>
                                            </v-list-item>                                                                                                                                                             
                                        </v-list-item-group>
                                    </v-list>
                                    <v-btn block @click="gerarArquivo(dialogProdutoItem.downloadCompleto)" style="color:white;">Download do Kit Completo</v-btn>                                    
                                </v-flex>
                            </v-col>                            
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-layout>
</template>


<script>
import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import breadcrumbs from "@/components/portal/layout/Breadcrumbs";
import listaProdutosPrevisul from '@/assets/jsonStore/ProdutosPrevisul.json';


export default {
  components: {
    breadcrumbs
  },
  data() {
      return {
        tab:1,
        guia: "Produtos > E-mail",
        tabOptions: [
            { id: 1, titulo: "PARA VOCÊ"},
            { id: 2, titulo: "PARA EMPRESAS"}
        ],    
        guiaMateriais: 'Guia de Materiais de Vendas',
        guiaMateriaisLinks: [
            { linha : [{ indice: 0, texto: "O que são os <br />Materiais de Vendas?", item: "" }, { indice: 1, texto: "Por que utilizar os <br />Materiais de Vendas?", item: "" }] },
            { linha : [{ indice: 2, texto: "Como utilizar os <br />Materiais de Vendas?", item: "" }, { indice: 3, texto: "Atenção: informação importante", item: "" }] },
        ],
        produtos: listaProdutosPrevisul.Produtos,
        dialogProduto: false,
        dialogProdutoItemSelecionadoIndex: 0,
        dialogProdutoItemSelecionado: 0,
        dialogProdutoItem:{
            nome : "",
            atualizadoEm : "",
            downloadCompleto : "",
            documentos : [{ icon: "", tipo: "",preview: "",download: ""}]
        },
        dialogGuia: false,
        dialogGuiaItemSelecionadoIndex: 0,
        dialogGuiaItemSelecionado: 0,
        dialogGuiaItems: [
            "O que são os Materiais de Vendas?",
            "Por que utilizar os Materiais de Vendas?",
            "Como utilizar os Materiais de Vendas?",
            "Atenção: informação importante"
        ],
        baseUrl: process.env.VUE_APP_POST_LOGOUT_REDIRECT_URI
      }
  },
    methods: {
        reiniciar()
        {
            this.dialogProdutoItemSelecionadoIndex = 0;
            this.dialogProdutoItem = {
                nome : "",
                atualizadoEm : "",
                downloadCompleto : "",
                documentos : [{ icon: "", tipo: "",preview: "",download: ""}]
            };
        },
        requestProdutos()
        {
            this.produtos.sort((a,b) => {
                let docA = a.nome.toLowerCase(),
                    docB = b.nome.toLowerCase();
                    
                if(docA < docB)
                {
                    return -1;
                }
                if(docA > docB)
                {
                    return 1;
                }                

                return 0;  
            });
        },
        gerarArquivo(value){
            //window.open(value, "_blank");
            let _arrayLink = value.split('/');
            let link = document.createElement('a');
            link.href = this.baseUrl+value;
            link.download = _arrayLink[_arrayLink.length-1];
            link.click(); 
        },
        changeTab(value){
            this.tab = value;
            this.guia = "Produtos > " + this.tabOptions[value - 1].titulo;
        },
        abrirPopUpProduto(item)
        {
            this.dialogProdutoItemSelecionado = 0;
            this.dialogProdutoItemSelecionadoIndex = 0;
            this.dialogProduto = true;
            this.dialogProdutoItem = item;
        },
        validarPreview(objeto, caminho)
        {
            if (objeto == 'pdf' && caminho.indexOf('.pdf') !== -1)
            {
                return true;
            }

            if(objeto == 'img')
            {
                if (caminho.indexOf('.png') !== -1 || caminho.indexOf('.jpg') !== -1)
                {
                    return true;
                }   
            }

            if (objeto == 'video' && caminho.indexOf('.mp4') !== -1)
            {
                return true;
            }

            return false;
        },
        abrirDialogGuia(index)
        {
            this.dialogGuiaItemSelecionado = index;
            this.dialogGuia = true;
        }
    },
    computed: {
    ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
    },
    mounted(){
        this.usuario;
        this.requestProdutos();
    },
    watch:{
        dialogProdutoItemSelecionado(value)
        {
            if (value != undefined)
            {
                this.dialogProdutoItemSelecionadoIndex = value;
            }
        },
        dialogGuiaItemSelecionado(value)
        {
            if (value != undefined)
            {
                this.dialogGuiaItemSelecionadoIndex = value;
            }
        }
    }        
};
</script>
<style lang="scss">
.bgCinza {
    background-color: var(--background) !important;
}
.bgCinza h1:first-child{
    color: var(--grey-medium) !important;
    font-weight: bold !important;
}
.btnGuia {
    color: var(--blue-medium) !important;
    text-align: start;
}
.cardTitulo {
    color: var(--blue-dark2) !important;
    font-weight: bold !important;
}

.tituloLista {
    color: var(--blue-dark2) !important;
    font-weight: bold !important;
    font-size: 20px;
}

.miniIconAzul {
    color: var(--blue-medium2) !important;
}

.miniIconAzul font{
    color: var(--grey-medium) !important;
}

</style>
